import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import { LogoutOutlined, PersonOutline, Settings as SettingsIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../hooks/useTranslation';
import { useRole } from '../../hooks/useRole';
import LanguageSwitcher from '../LanguageSwitcher';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const { canViewData } = useRole();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
  };

  const handleSettingsClick = () => {
    navigate('/settings');
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {t('navigation.managementSystem')}
        </Typography>

        {user && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <LanguageSwitcher />

            {/* 設置按鈕 - 只有有權限的用戶才能看到 */}
            {canViewData && (
              <Tooltip title="用戶管理">
                <IconButton
                  color="inherit"
                  onClick={handleSettingsClick}
                  sx={{
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)'
                    }
                  }}
                >
                  <SettingsIcon />
                </IconButton>
              </Tooltip>
            )}

            <PersonOutline sx={{ mr: 1 }} />
            <Typography variant="body1" sx={{ mr: 2 }}>
              {user.nickName}
            </Typography>
            <Button
              color="inherit"
              onClick={handleLogout}
              startIcon={<LogoutOutlined />}
            >
              {t('auth.logout')}
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;